var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconExpandSidebar = function SvgIconExpandSidebar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1B1A1F",
    d: "M12.452 8.414v7.172L16.048 12zM5.308 20.5q-.748 0-1.278-.53a1.74 1.74 0 0 1-.53-1.278V5.308q0-.748.53-1.278t1.278-.53h13.384q.749 0 1.278.53.53.53.53 1.278v13.384q0 .749-.53 1.278-.53.53-1.278.53zM8 19V5H5.308a.3.3 0 0 0-.212.096.3.3 0 0 0-.096.212v13.384q0 .116.096.212a.3.3 0 0 0 .212.096zm1.5 0h9.192a.3.3 0 0 0 .212-.096.3.3 0 0 0 .096-.212V5.308a.3.3 0 0 0-.096-.212.3.3 0 0 0-.212-.096H9.5z"
  })));
};
export default SvgIconExpandSidebar;